/** The small flag drawn on "Report this message" buttons (room chat and private messages) and on quoted reports. */
export function ReportFlagIcon({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M5 21V4.5M5 4.5h11l-2 4 2 4H5" />
    </svg>
  );
}
